import script from "./HelperResources.vue?vue&type=script&setup=true&lang=js"
export * from "./HelperResources.vue?vue&type=script&setup=true&lang=js"

import "./HelperResources.vue?vue&type=style&index=0&id=227cb34e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-227cb34e"]])

export default __exports__